// extracted by mini-css-extract-plugin
export default {"TableMedusa":"Table_TableMedusa__hnGyq"};